import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../style.css";

const SYSTEMS = [
  { key: 'erpMini',    title: 'ERP Mini',        path: '/erpMini',                     tag: 'ERP' },
  { key: 'platformAI', title: 'AI B2B Platform',  path: 'https://platform.apetechs.co/', tag: 'AI', isExternal: true },
  { key: 'crm',        title: 'CRM',              path: '/crm',                          tag: 'Sales' },
  { key: 'dms',        title: 'DMS',              path: '/dms',                          tag: 'Sales' },
  { key: 'pm',         title: 'PM',               path: '/pm',                           tag: 'Project' },
  { key: 'hrm',        title: 'HRM',              path: '/hrm',                          tag: 'HR' },
  { key: 'pms',        title: 'PMS',              path: '/pms',                          tag: 'Procurement' },
  { key: 'mes',        title: 'MES',              path: '/mes',                          tag: 'Production' },
  { key: 'tms',        title: 'TMS',              path: '/tms',                          tag: 'Logistics' },
  { key: 'wms',        title: 'WMS',              path: '/wms',                          tag: 'Warehouse' },
  { key: 'eam',        title: 'EAM',              path: '/eam',                          tag: 'Asset' },
  { key: 'apexLink',   title: 'APExLINK',         path: 'https://apexlink.dev/',         tag: 'Blockchain', isExternal: true },
];

interface AppModalProps {
  visible: boolean;
  onClose: () => void;
}

const AppModal = ({ visible, onClose }: AppModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('home');

  const handleClick = (item: typeof SYSTEMS[0]) => {
    if (item.isExternal && item.path) {
      window.open(item.path, "_blank", "noopener noreferrer");
      onClose();
      return;
    }
    if (item.path) {
      navigate(item.path);
      onClose();
      return;
    }
    navigate("/");
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      closeIcon={<CloseOutlined style={{ color: "#94A3B8" }} />}
      styles={{
        content: {
          background: "#111111",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 12,
          padding: "32px",
        },
        mask: {
          backdropFilter: "blur(4px)",
        },
      }}
    >
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <div style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 11,
          color: "#FBAD16",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          marginBottom: 8,
        }}>
          {t('modal.label')}
        </div>
        <div style={{
          fontSize: 22,
          fontWeight: 700,
          color: "#E2E8F0",
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          {t('modal.title')}
        </div>
        <div style={{
          fontSize: 13,
          color: "#64748B",
          marginTop: 6,
          fontFamily: "'JetBrains Mono', monospace",
        }}>
          {t('modal.subtitle')}
        </div>
      </div>

      {/* Grid */}
      <div className="dev-modal-grid">
        {SYSTEMS.map((item) => (
          <div
            key={item.key}
            className="dev-modal-card"
            onClick={() => handleClick(item)}
          >
            <div className="dev-modal-card-top">
              <div className="dev-modal-card-tag">{item.tag}</div>
              {item.isExternal && (
                <span className="dev-modal-card-ext">↗</span>
              )}
            </div>
            <div className="dev-modal-card-title">{item.title}</div>
            <div className="dev-modal-card-desc">{t(`systems.${item.key}.desc`)}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default AppModal;
